import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { AllCommunityModules } from '@ag-grid-community/all-modules';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { GridOptions } from 'ag-grid-community';
import { ButtonRendererComponent } from 'src/common/button-renderer.component';
import { ConfirmationDialogComponent } from 'src/common/confirmation-dialog/confirmation-dialog.component';
import { USER_ID } from 'src/common/keys';
import { NameRendererComponent } from 'src/common/name-renderer';
import { ViewRendererComponent } from 'src/common/view-renderer';
import { BusinessInformationService } from 'src/services/business-information.service';
import { LocalstorageService } from 'src/services/localstorage.service';
import { NgxToasterService } from 'src/services/ngx-toaster.service';

@Component({
  selector: 'app-work-group',
  templateUrl: './work-group.component.html',
  styleUrls: ['./work-group.component.css']
})
export class WorkGroupComponent implements OnInit {
  public defaultColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    flex: 1,
  };
  public columnDefs = [
    {
      field: 'orderNumber',
      rowDrag: true,
    },
    {
      headerName: 'Workgroup Name',
      field: 'workgroupName',
      cellRenderer: 'nameRenderer',
      cellRendererParams: {
        onClick: this.openAddDialog.bind(this),
      },
      width: 250
    },
    {
      headerName: 'Template',
      field: '',
      resizable: true,
      filter: false,
      cellRenderer: 'viewRenderer',
      cellRendererParams: {
        onClick: this.openDialogTemplate.bind(this),
      },
      width: 80
    },
    {
      headerName: '',
      field: 'delete',
      resizable: true,
      filter: false,
      cellRenderer: 'deleteButtonRenderer',
      cellRendererParams: {
        onClick: this.openRemoveGoalDialog.bind(this),
      },
      width: 80
    },
  ];
  public gridOptions: GridOptions;
  public info: string;
  private gridApi: any;
  public workgroupList = [];
  public answerTypeList = [];
  public modules = AllCommunityModules;
  public user: any;
  public gridColumnApi: any;
  public businessInfoForm: FormGroup;
  public isEdit = false;
  public frameworkComponents = {
    deleteButtonRenderer: ButtonRendererComponent,
    nameRenderer: NameRendererComponent,
    viewRenderer: ViewRendererComponent
  };
  public columnAttDefs = [
    {
      headerName: 'Title',
      field: 'title',
      cellRenderer: 'nameRenderer',
      cellRendererParams: {
        onClick: this.openAddDialog.bind(this),
      },
      pinned: 'left',
      width: 250
    },
    {
      headerName: 'Type',
      field: 'type'
    },
    {
      headerName: '',
      field: 'delete',
      resizable: true,
      filter: false,
      cellRenderer: 'deleteButtonRenderer',
      cellRendererParams: {
        onClick: this.openRemoveGoalDialog.bind(this),
      },
      width: 80
    }
  ];
  public attributeList = [];
  public businessInfoAttForm: FormGroup;
  @ViewChild('Adddialog') dialogAddTemplate: TemplateRef<any>;
  @ViewChild('templateDialog') templateDialog: TemplateRef<any>;
  @ViewChild('AttributeDialog') AttributeDialog: TemplateRef<any>;
  constructor(
    public router: Router,
    public businessInfoService: BusinessInformationService,
    public dialog: MatDialog,
    public formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<any>,
    public storage: LocalstorageService,
    public confirmationDialogRef: MatDialogRef<ConfirmationDialogComponent>,
    public spinner: NgxSpinnerService,
    public toastr: NgxToasterService) {
    this.gridOptions = {
      rowDragManaged: true,
      animateRows: true,
      pagination: true,
      paginationAutoPageSize: true,
    };
  }
  ngOnInit() {
    this.initializeForm();
    this.initializeAttForm();
    this.getWorkgroupList();
    this.getAttributeList();
  }
  public getWorkgroupList = () => {
    this.businessInfoService.getWorkGroupList({}).subscribe(res => {
      this.workgroupList = res.map(row => ({ ...row, orderNumber: row.workgroupId }));
    });
  }
  openRemoveGoalDialog(row: any): void {
    // tslint:disable-next-line: no-use-before-declare
    this.confirmationDialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '500px',
      data: { headerName: row.rowData.title }
    });

    this.confirmationDialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.removeItemMaster(row.rowData);
      }
    });
  }
  public openDialogTemplate(data) {
    const dialogRef = this.dialog.open(this.templateDialog, { width: '800px', data: data || {} });
  }
  public openAddAttributeDialog(data) {
    const dialogRef = this.dialog.open(this.AttributeDialog, { width: '800px', data: data || {} });
  }
  public removeItemMaster(selectedItem: any) {
    if (selectedItem) {
      const model = {
        ...selectedItem,
        active: false
      };
      this.spinner.show();
      this.businessInfoService.activateWorkGroup(model).subscribe(res => {
        if (res) {
          this.spinner.hide();
          this.toastr.success('Master Items', 'Item removed successfully');
          this.workgroupList = this.workgroupList.filter(row => row.workgroupId !== model.workgroupId);
          this.gridOptions.api.setRowData(this.workgroupList);
        }
      }, error => {
        this.spinner.hide();
        this.toastr.error('Master Items', error.error.text);
      });
    }
  }
  public initializeForm = () => {
    this.businessInfoForm = this.formBuilder.group({
      workgroupName: [],
      workgroupId: [0],
      createdById: [this.storage.get(USER_ID)],
      active: true
    });
  }
  public initializeAttForm = () => {
    this.businessInfoAttForm = this.formBuilder.group({
      title: [],
      bussinessAttributeId: [],
      answerTypeId: [],
      code: [],
      createdById: [this.storage.get(USER_ID)],
      active: true
    });
  }
  public getAttributeList = () => {
    this.answerTypeList = [
      { answerTypeId: 1, name: 'Text' },
      { answerTypeId: 2, name: 'Single Select' },
      { answerTypeId: 3, name: 'Multi Select' },
      { answerTypeId: 4, name: 'View' }
    ];
    this.businessInfoService.getBusinessAttributeList({}).subscribe(res => {
      this.attributeList = res.map(row => ({
        ...row, type: this.answerTypeList.find(ans => ans.answerTypeId === row.answerTypeId).name
      }));
    });
  }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridOptions = params;
    // params.api.sizeColumnsToFit();
  }

  onFilterTextBoxChanged(event) {
    this.gridOptions.api.setQuickFilter(event.target.value);
  }
  onCellClicked($event) {

    this.router.navigate(['addUser'], {
      queryParams: {
        id: btoa($event.data.userId)
      }
    });
  }
  public navigateToRoles = () => {
    this.router.navigate(['Roles']);
  }
  openAddDialog(data, templateRef?: TemplateRef<any>): void {
    if (data && data.rowData) {
      this.isEdit = true;
      Object.keys(this.businessInfoForm.controls).forEach(key => {
        this.businessInfoForm.controls[key].setValue(data.rowData[key]);
      });
    }
    this.dialogRef = this.dialog.open(this.dialogAddTemplate, { width: '500px', data: data || {} });
  }
  public onSubmit = () => {
    const model = this.businessInfoForm.value;
    this.spinner.show();
    if (this.isEdit) {
      this.businessInfoService.updateWorkGroup(model).subscribe(res => {
        const index = this.workgroupList.findIndex(row => row.workgroupId === model.workgroupId);
        if (index > -1) {
          this.workgroupList[index] = model;
        }
        this.gridOptions.api.setRowData(this.workgroupList);
        this.dialogRef.close();
        this.spinner.hide();
      }, error => {
        this.spinner.hide();
      });
    } else {
      this.businessInfoService.addWorkGroup(model).subscribe(res => {
        model.workgroupId = res;
        this.workgroupList.push(model);
        this.gridOptions.api.setRowData(this.workgroupList);
        this.dialogRef.close();
        this.spinner.hide();
      }, error => {
        this.spinner.hide();
      });
    }
  }
}
